import React, { useState, useEffect } from "react"
import styled from "styled-components"
import concatWithSpaces from "../../../../../ProjectNonSpecificComponents/Functions/concatWithSpaces"
import { forwardRef } from "react"
import Input from "../../../../../ProjectNonSpecificComponents/Elements/Input"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { useTranslation } from "react-i18next"
import InfoBubble from 'components/ProjectSpecificComponents/Elements/Global/atoms/InfoBubble'

interface Props extends React.ComponentProps<"input"> {
	width?: number | string
	height?: number | string
	tooltipText?: string
	searchStyle?: React.CSSProperties
}

/**
 * Set the width and height of the container by passing in css values
 * in props `width` and `height`.
 */
const SearchBar = forwardRef<HTMLInputElement, Props>(
	(
		{
			tooltipText = "",
			width,
			height,
			onFocus = () => {},
			onBlur = () => {},
			className,
			searchStyle,
			...props
		}: Props,
		ref
	) => {
		const { t } = useTranslation()
		const [isContainerHovered, setIsContainerHovered] = useState(false)
		const [isInputFocused, setIsInputFocused] = useState(false)
		const [isSearchBarFocused, setIsSearchBarFocused] = useState(false)

		const _onFocus = (e: any) => {
			setIsInputFocused(true)
			onFocus(e)
		}
		const _onBlur = (e: any) => {
			setIsInputFocused(false)
			onBlur(e)
		}

		useEffect(() => {
			if (isInputFocused) setIsSearchBarFocused(true)
			if (isContainerHovered) setIsSearchBarFocused(true)
			if (!isInputFocused && !isContainerHovered) setIsSearchBarFocused(false)
		}, [isContainerHovered, isInputFocused])

		return (
			<HyperDiv
				direction="row"
				width={width}
				height={height}
				margin="0px 0px 5px 2px"
				onMouseEnter={() => setIsContainerHovered(true)}
				onMouseLeave={() => setIsContainerHovered(false)}
				centeredY
				style={{ ...searchStyle }}
			>
				<Input
					{...props}
					className={concatWithSpaces("fill-cter", className)}
					ref={ref}
					onFocus={_onFocus}
					onBlur={_onBlur}
					style={{
						fontSize: 14,
						height: 50,
						fontWeight: 400,
						maxWidth: 200,
					}}
				/>
				{tooltipText && (
					<IconBox className="center-x-y pointer non-draggable ">
						<InfoBubble tooltipText={tooltipText} />
					</IconBox>
				)}
			</HyperDiv>
		)
	}
)

export default SearchBar

const IconBox = styled.div`
	width: 48px;
	color: var(--white);
	background-color: var(--deep-blue);

	padding: 8px;
	// Centering of img
	padding-right: 9px;
	padding-bottom: 9px;
	box-sizing: border-box;

	// Animation
	transition: 0.2s var(--default-slide-transition-fn);
	transition-property: background-color;
`
